import { useLocation, useNavigate } from 'react-router-dom';
import Dialog from '@/components/Dialog.tsx';

const AccessWarning = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Back to wherever the user came from; a direct visit (no in-app history) lands on the dashboard.
  const onClose = () => (location.key === 'default' ? navigate('/dashboard', { replace: true }) : navigate(-1));

  return (
    <Dialog
      title=""
      description={(
        <>
          To access the STUDY CENTER, you must be a SATPRAC COMPLETE MEMBER.
          Click on SATPRAC PACKAGES to UPGRADE and UNLOCK the study center, 100+ hours of video tutorials,
          MODULE MODE, and more!
        </>
      )}
      open
      onClose={onClose}
      cancelText="Close"
    />
  );
};

export default AccessWarning;
